import { createFileRoute } from "@tanstack/react-router";
import AdminErrorReports from "@/pages/AdminErrorReports";

export const Route = createFileRoute("/admin/error-reports/")({
  component: AdminErrorReports,
});
